const isMac = /mac|ipad|iphone|darwin/i.test(navigator.userAgent);
export {
  isMac as i
};
//# sourceMappingURL=platform-CC2ecGvV.mjs.map
